import React from 'react';
import PropTypes from 'prop-types';
import { Radio, Checkbox } from '@gasbuddy/react-components';


import styles from './styles.css';

const { getQueryParameters, setQueryParameter, removeQueryParameter } = require('../../../../lib/bputils').default;

const FilterPropsType = PropTypes.shape({
  header: PropTypes.string,
  type: PropTypes.oneOf(['radio', 'checkbox']),
  values: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  })),
});

const FiltersPropsType = PropTypes.arrayOf(FilterPropsType);

export default function Filter({ name, filters, selected: selectedProps, onChange, queryParamId }) {
  const [showDropdown, setShowDropdown] = React.useState(false);
  const [selected, setSelected] = React.useState(selectedProps);

  React.useEffect(() => {
    if (queryParamId) {
      const queryParam = getQueryParameters()[queryParamId];
      if (queryParam && queryParam.length) {
        setSelected(queryParam.split(','));
      }
    }
  }, []);

  React.useEffect(() => {
    if (onChange) {
      onChange(selected);
    }
  }, [selected, onChange]);

  React.useEffect(() => {
    if (queryParamId && selected.length) {
      setQueryParameter(queryParamId, selected);
    } else if (queryParamId && !selected.length) {
      removeQueryParameter(queryParamId);
    }
  }, [selected, queryParamId]);

  const handleOnCheckboxToggle = (value, toggle) => {
    if (toggle) {
      setSelected([value, ...selected]);
    } else {
      setSelected(selected.filter(val => val !== value));
    }
  };

  const renderCheckbox = (label, value) => (
    <Checkbox
      id={value}
      label={label}
      checked={selected.includes(value)}
      onChange={() => handleOnCheckboxToggle(value, !selected.includes(value))}
      className={styles.filterOption}
    />
  );

  const handleOnRadioToggle = (value) => {
    if (!selected.includes(value)) {
      const filterGroup = filters.find(filter => filter.values.map(val => val.value).includes(value));
      const radioGroupValues = filterGroup.values.map(val => val.value);
      setSelected([...selected.filter(val => !radioGroupValues.includes(val)), value]);
    } else {
      setSelected([...selected.filter(val => val !== value)]);
    }
  };

  const renderRadioButton = (label, value) => (
    <div>
      <Radio
        id={value}
        name={label}
        value={value}
        checked={selected.includes(value)}
        className={styles.filterOption}
        onClick={() => handleOnRadioToggle(value)}
      >
        &nbsp;&nbsp;
        {label}
      </Radio>
    </div>
  );

  return (
    <div
      className={styles.filterContainer}
      onMouseEnter={() => setShowDropdown(true)}
      onMouseLeave={() => setShowDropdown(false)}
    >
      <div className={styles.filterName}>{name}</div>
      <div className={`${styles.filterDropdown} ${showDropdown ? styles.show : ''}`}>
        {filters.map(filter => (
          <>
            {filter.type === 'checkbox'
              && (
                <div className={styles.filterOptGroup} style={{ borderWidth: '0px' }}>
                  {filter.name && <p className={styles.filterOptGroupLabel}>{filter.name}</p>}
                  {filter.values.map(option => renderCheckbox(option.label, option.value))}
                </div>
              )
            }
            {filter.type === 'radio' && (
              <form className={styles.filterOptGroup} style={{ borderWidth: '0px' }}>
                {filter.name && <p className={styles.filterOptGroupLabel}>{filter.name}</p>}
                {filter.values.map(option => renderRadioButton(option.label, option.value))}
              </form>
            )}
          </>
        ))}
      </div>
    </div>
  );
}

Filter.propTypes = {
  name: PropTypes.string.isRequired,
  filters: FiltersPropsType.isRequired,
  selected: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func,
  queryParamId: PropTypes.string,
};

Filter.defaultProps = {
  selected: [],
  onChange: () => {},
  queryParamId: null,
};
